export const objectsStats = [
    { name: "Nome", value: "name", filter: false },
    { name: "Plano", value: "lessonPlan", filter: false },
    { name: "Gostou", value: "liked", filter: false, image: true, iconName: 'md-thumbup-outlined' },
    { name: "Não gostou", value: "disliked", filter: false, image: true, iconName: 'md-thumbdown-outlined' },
  ];